module.exports = __webpack_public_path__ + "static/media/gsuite-engagement.bed920dd.png";